module.exports = __webpack_public_path__ + "img/academy-badge-certified-fundamentals.28d63f0.svg";